import Icon from '@mdi/react';
import React from 'react';
import {
    ACTION_FIRES_HELPERS,
    ACTION_OUTCOME_PILLS,
    ACTION_SUMMARY_HEADERS,
} from '../../../services/worker-configuration/automation/worker-automation.constants';
import { RuleActionType } from '../../../services/worker-configuration/automation/worker-automation.types';
import { resolveRuleActionType } from '../../../services/worker-configuration/automation/worker-automation.utils';
import * as S from './configuration-rule.styles';

interface IConfigurationActionSummaryProps {
    actionType: RuleActionType | string;
}

export const ConfigurationActionSummary: React.FC<IConfigurationActionSummaryProps> = ({
    actionType,
}) => {
    const resolvedType = resolveRuleActionType(actionType);
    if (!resolvedType) {
        return null;
    }

    const pills = ACTION_OUTCOME_PILLS[resolvedType] ?? [];
    const header = ACTION_SUMMARY_HEADERS[resolvedType];
    if (!header) {
        return null;
    }

    return (
        <S.ActionSummary>
            <S.ActionSummaryHeader>
                <S.ActionSummaryIcon>
                    <Icon path={header.icon} size={0.95} aria-hidden={true} />
                </S.ActionSummaryIcon>
                <S.ActionSummaryTitle>{header.title}</S.ActionSummaryTitle>
            </S.ActionSummaryHeader>
            <S.ActionFiresText>{ACTION_FIRES_HELPERS[resolvedType]}</S.ActionFiresText>
            {pills.length > 0 && (
                <S.ActionOutcomeRow>
                    {pills.map(pill => (
                        <S.ActionOutcomePill key={pill.label}>
                            <Icon path={pill.icon} size={0.7} aria-hidden={true} />
                            {pill.label}
                        </S.ActionOutcomePill>
                    ))}
                </S.ActionOutcomeRow>
            )}
        </S.ActionSummary>
    );
};

interface IConfigurationFieldLabelProps {
    children: React.ReactNode;
    helper?: string;
    optional?: boolean;
}

export const ConfigurationFieldLabel: React.FC<IConfigurationFieldLabelProps> = ({
    children,
    helper,
    optional,
}) => (
    <div>
        <S.FieldLabelRow>
            <S.FieldLabel style={{ marginBottom: 0 }}>{children}</S.FieldLabel>
            {optional && <S.FieldLabelOptional>· optional</S.FieldLabelOptional>}
        </S.FieldLabelRow>
        {helper && <S.FieldHelper>{helper}</S.FieldHelper>}
    </div>
);

export const ConfigurationRequiredMark: React.FC = () => (
    <S.FieldLabelOptional>· required</S.FieldLabelOptional>
);

interface IConfigurationFieldErrorProps {
    inset?: boolean;
    message?: string | null;
}

export const ConfigurationFieldError: React.FC<IConfigurationFieldErrorProps> = ({
    inset,
    message,
}) => {
    if (!message) {
        return null;
    }

    const Error = inset ? S.MatchBlockFieldError : S.FieldError;
    return <Error>{message}</Error>;
};
